import React from "react";
import { Typography } from "@material-ui/core";
import clsx from "clsx";
import CustomButton from "../../customButton/customButton";
import * as colors from "../../../theme/colors";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  card: {
    border: `1px solid ${colors.grey300}`,
    borderRadius: 5,
    padding: 15,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    textAlign: "left",
    boxShadow: `0 1px 3px ${colors.faintBlack}`,
  },
  cardContentWrapper: {
    display: "flex",
    alignItems: "center",
    marginBottom: 10,
  },
  iconCircle: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    marginRight: 10,
  },
  cardTitle: {
    fontWeight: 600,
    fontSize: 16,
  },
  cardText: {
    fontSize: 13,
    color: colors.grey600,
    marginBottom: 15,
  },
}));

const BlockJamCard = ({
  title,
  text,
  icon,
  iconWrapperClass,
  buttonLabel = "Build Now",
  onClick,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.card}>
      <div className={classes.cardContentWrapper}>
        <div className={clsx(classes.iconCircle, iconWrapperClass)}>
          {icon}
        </div>
        <Typography className={classes.cardTitle}>{title}</Typography>
      </div>

      <Typography className={classes.cardText}>{text}</Typography>

      <CustomButton
        mode="primary"
        label={buttonLabel}
        onClick={onClick}
      />
    </div>
  );
};

export default BlockJamCard;
